import { useJobContext } from 'pages/Job/context';
import { useMemo } from 'react';

export interface JobChangesRequestedHook {
  show: boolean;
  request: string | undefined;
}

export default function useJobChangesRequested(): JobChangesRequestedHook {
  const { job, changesRequested } = useJobContext();
  const request = useMemo(() => {
    if (!job) return undefined;
    const { current_step: currentStep } = job;
    if (!currentStep) return undefined;
    return currentStep.text;
  }, [job]);
  return {
    show: changesRequested,
    request,
  };
}
